module.exports = __webpack_public_path__ + "assets/img/1b055ea34afd623b4b0c211222c084a9.svg";